export const TOKEN_KEY = 'gov-backend-web-token'
export const ACCOUNT_NAME_KEY = 'gov-backend-web-account'

export const REGISTER_STATUS_MAP = {
  0: '待处理',
  5: '处理中',
  10: '已完成',
  20: '已关闭'
}

export const FORM_LAYOUT = {
  labelCol: { span: 6 },
  wrapperCol: { span: 18 }
}

export const mobileValidator = (rule, value) => {
  if (!value || !value.trim()) {
    return Promise.reject(new Error('手机号不能为空'))
  }
  if (!/^1\d{10}$/.test(value)) {
    return Promise.reject(new Error('请输入合法的手机号'))
  }

  return Promise.resolve()
}

